/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Banner_TitleInputs */

const en_compliance_banner_title = /** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance Action Required`)
};

const es_compliance_banner_title = /** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción de Cumplimiento Requerida`)
};

const fr_compliance_banner_title = /** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action de conformité requise`)
};

const de_compliance_banner_title = /** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance-Maßnahme erforderlich`)
};

const id_compliance_banner_title = /** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan Kepatuhan Diperlukan`)
};

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const ja_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const zh_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const ar_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const it_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const ru_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const pt_compliance_banner_title = en_compliance_banner_title;

/** @type {(inputs: Compliance_Banner_TitleInputs) => LocalizedString} */
const ko_compliance_banner_title = en_compliance_banner_title;

/**
* | output |
* | --- |
* | "Compliance Action Required" |
*
* @param {Compliance_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const compliance_banner_title = /** @type {((inputs?: Compliance_Banner_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Banner_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compliance_banner_title(inputs)
	if (locale === "es") return es_compliance_banner_title(inputs)
	if (locale === "fr") return fr_compliance_banner_title(inputs)
	if (locale === "de") return de_compliance_banner_title(inputs)
	if (locale === "ja") return ja_compliance_banner_title(inputs)
	if (locale === "zh") return zh_compliance_banner_title(inputs)
	if (locale === "ar") return ar_compliance_banner_title(inputs)
	if (locale === "id") return id_compliance_banner_title(inputs)
	if (locale === "it") return it_compliance_banner_title(inputs)
	if (locale === "ru") return ru_compliance_banner_title(inputs)
	if (locale === "pt") return pt_compliance_banner_title(inputs)
	return ko_compliance_banner_title(inputs)
});